import React from 'react';

import {Stack, Skeleton} from 'views/components';

const LargeSkeleton = () => {
  return (
    <Stack spacing={2} height={'100%'}>
      <Stack direction={'row'} spacing={4} height={'20%'}>
        <Skeleton variant="text" height={'100%'} width={'25%'}/>
        <Skeleton variant="text" height={'100%'} width={'25%'}/>
        <Skeleton variant="text" height={'100%'} width={'25%'}/>
        <Skeleton variant="text" height={'100%'} width={'25%'}/>
      </Stack>
      <Skeleton variant="rounded" height={'20%'}/>
      <Skeleton variant="rounded" height={'20%'}/>
      <Skeleton variant="rounded" height={'20%'}/>
      <Skeleton variant="rounded" height={'20%'}/>
    </Stack>
  );
};


export default React.memo(LargeSkeleton);
